
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect } from "react"
import textFilter from "../../../../helper/textFilter"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { setIsDurationStrict, updateTonajData, updateTonajOptions, updateTruckType } from "../../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import aracTonajOptions from "../../../../utils/yukOptions/nakliyeFiyatHesaplamaTonajOptions"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: auto;
        overflow: auto;

        .option{
            width: 100%;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0px 10px;
            border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

            .img-wrapper{
                width: 150px;
                display: flex;
                justify-content: flex-end;
                padding: 5px;
                
                .option-img{
                    width: auto;
                    height: 28px;
                }
                }

            .option-text{
                color: ${({theme}) => theme.mainTextColor};
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);

            }

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }
`

//! new
const InputAracType = ({data, isRequired, labelText, name, keyData, inputWidth, initialOptions}) => {

    const [text, setText] = useState(data?.text)
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const [options, setOptions] = useState(initialOptions)

    useEffect(() => {
        setText(data?.text)
    },[data])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(initialOptions)
            // dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilter(initialOptions, searchText, "text")
            setOptions(result)
        }
        setText(searchText)
    }

    const handleOptionClick = (item) => {

        dispatch(updateTruckType(item))
        dispatch(handleActiveSelect(null))

        if(item?.id){
            dispatch(setIsDurationStrict(false))
            const tonajList= aracTonajOptions.find(aracItem => aracItem.aracTypeId === item?.id).tonajOptions
            dispatch(updateTonajData(tonajList[tonajList.length -1]))
            dispatch(updateTonajOptions(tonajList))
        }
    }


  return (
    <Container onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} value={text} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth}>
        <input type="text" id={"text"} onChange={(e) =>handleChange(e)} value={text} name={"text"}  autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options.map((item, i) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                <span className="option-text">{item.text}</span>
                                <div className="img-wrapper">
                                    <img src={item.svg} className="option-img" alt="" />
                                </div>
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputAracType